﻿// ----------------------------------------------------------------------------
// Main index file, export function iipInitModel, require classic js iip.vendor.js
// ----------------------------------------------------------------------------

// css
import './scss/vxiip.scss';

function doClick(e, myIIPMooViewer) {
    console.log(JSON.stringify(myIIPMooViewer.scale));
    let str = JSON.stringify(e, null, 4);
    console.log(str);
    str = JSON.stringify(myIIPMooViewer.view);
    console.log(str);

    str = JSON.stringify(myIIPMooViewer.canvas);
    console.log(str);
    console.log("wid: " + myIIPMooViewer.wid + ", hei:" + myIIPMooViewer.hei);

    str = JSON.stringify(myIIPMooViewer.getView());
    console.log(str);

    str = JSON.stringify(myIIPMooViewer.scale);
    console.log(str);

    var x = e.page.x - myIIPMooViewer.containerPosition.x + myIIPMooViewer.view.x - ((myIIPMooViewer.wid < myIIPMooViewer.view.w) ? Math.round((myIIPMooViewer.view.w - myIIPMooViewer.wid) / 2) : 0);
    var ry = e.page.y - myIIPMooViewer.containerPosition.y + myIIPMooViewer.view.y - ((myIIPMooViewer.hei < myIIPMooViewer.view.h) ? Math.round((myIIPMooViewer.view.h - myIIPMooViewer.hei) / 2) : 0);
    var y = myIIPMooViewer.hei - ry;
    var text = myIIPMooViewer.images[0].src + ' (' + myIIPMooViewer.transformCoords(x / myIIPMooViewer.wid, y / myIIPMooViewer.hei) + ')';

    alert(text);

    str = JSON.stringify(text);
    console.log(str);

    return;

};

var annotations = {
    1: { x: 0.7, y: 0.6, w: 0.2, h: 0.18, category: "gigapan", title:'pippo', text: "prussian blue" },
    2: { x: 0.1, y: 0.8, w: 0.15, h: 0.1, category: "gigapan", text: "azurite" },
    3: { x: 0.7, y: 0.4, w: 0.1, h: 0.1, category: "gigapan", text: "Mary" }
};

export function iipInitModel(myGigapan) {
    
    // Intercetta il click e mostra il marker
    var myIIPMooViewer;
    
    //var myviewport = { resolution: 7, x: 0.1, y: 0.1, rotation: 0 };
    // Inizializza il visualizzatore
    myIIPMooViewer = new IIPMooViewer("viewer", {
        scale: 1,
        units: 'meters',
        prefix: 'dist/iip/images/',
        image: myGigapan + ".tif", // Sostituisci con il percorso corretto
        showCoords: true,
        enableFullscreen: 'page',
        //annotations,
        //viewport: myviewport
    });
    myIIPMooViewer.click = function (e) { doClick(e, myIIPMooViewer); }
    //console.log(JSON.stringify(viewer.scale));
};

function doInitGallery(data, mydiv) {
    var gallery = new Gallery(mydiv, {
        images: data,
        prefix: 'dist/iip/images/'
    });
    //gallery.iipmooviewer.scale = 1;
    //gallery.iipmooviewer.units = 'meters';
    gallery.iipmooviewer.click = function (e) { doClick(e, gallery.iipmooviewer); };
    gallery.iipmooviewer.addEvent('imageChanged', function () {
        console.log(JSON.stringify(gallery.iipmooviewer.images));
    });

}
export function iipInitGallery(galleryurl, mydiv) {

    fetch(galleryurl)
        .then(response => response.json())
        .then(data => doInitGallery(data, mydiv))
        .catch(error => {
            console.error('Errore nel recupero dei dati:', error);
            alert('Errore recupero dati: ' + error);
        });

};